import { Typography } from './typography'

import { CodeExample } from '../demo/code-example'
import { DemoTabs } from '../demo/demo-tabs'

export function TypographyDemo() {
  return (
    <div className="space-y-2">
      <Typography variant="cf-heading-03" className="text-cf-grey-900">
        Typography
      </Typography>

      <DemoTabs
        tabs={{
          preview: (
            <>
              <div className="space-y-6">
                <div className="border-cf-grey-100 rounded-lg border p-6">
                  <Typography variant="cf-heading-03" className="text-cf-purple-700 mb-4 font-mono">
                    Title Variants
                  </Typography>
                  <div className="space-y-4">
                    <div className="space-y-2">
                      <Typography variant="cf-title-01">cf-title-01</Typography>
                      <Typography variant="cf-title-compact-01">cf-title-compact-01</Typography>
                      <Typography variant="cf-title-02">cf-title-02</Typography>
                      <Typography variant="cf-title-compact-02">cf-title-compact-02</Typography>
                      <Typography variant="cf-title-03">cf-title-03</Typography>
                      <Typography variant="cf-title-compact-03">cf-title-compact-03</Typography>
                      <Typography variant="cf-title-04">cf-title-04</Typography>
                      <Typography variant="cf-title-05">cf-title-05</Typography>
                      <Typography variant="cf-title-06">cf-title-06</Typography>
                      <Typography variant="cf-title-07">cf-title-07</Typography>
                      <Typography variant="cf-title-08">cf-title-08</Typography>
                      <Typography variant="cf-title-09">cf-title-09</Typography>
                      <Typography variant="cf-title-10">cf-title-10</Typography>
                      <Typography variant="cf-title-11">cf-title-11</Typography>
                      <Typography variant="cf-title-02-fc">cf-title-02-fc</Typography>
                      <Typography variant="cf-title-compact-02-fc">
                        cf-title-compact-02-fc
                      </Typography>
                    </div>
                    <CodeExample
                      code={`import { Typography } from '@repo/design-system-cf/components/typography'

// Title variants example
<Typography variant="cf-title-01">cf-title-01</Typography>
<Typography variant="cf-title-02">cf-title-02</Typography>
// ... and so on for other variants`}
                    />
                  </div>
                </div>

                <div className="border-cf-grey-100 rounded-lg border p-6">
                  <Typography variant="cf-heading-03" className="text-cf-purple-700 mb-4 font-mono">
                    Body Variants
                  </Typography>
                  <div className="space-y-4">
                    <div>
                      <div className="space-y-4">
                        <Typography variant="body-01">body-01</Typography>
                        <Typography variant="body-compact-01">body-compact-01</Typography>
                        <Typography variant="body-01-m">body-01-m</Typography>
                        <Typography variant="body-compact-01-m">body-compact-01-m</Typography>
                      </div>
                      <CodeExample
                        code={`import { Typography } from '@repo/design-system-cf/components/typography'

// Body 01
<Typography variant="body-01">
  body-01
</Typography>

// Body Compact 01
<Typography variant="body-compact-01">
  body-compact-01
</Typography>

// Body 01 Medium
<Typography variant="body-01-m">
  body-01-m
</Typography>

// Body Compact 01 Medium
<Typography variant="body-compact-01-m">
  body-compact-01-m
</Typography>`}
                      />
                    </div>

                    <div className="mt-8">
                      <Typography variant="cf-heading-02" className="text-cf-grey-800 mb-4">
                        Body 02 Variants
                      </Typography>
                      <div className="space-y-4">
                        <Typography variant="body-02">body-02</Typography>
                        <Typography variant="body-02-m">body-02-m</Typography>
                        <Typography variant="body-compact-02">body-compact-02</Typography>
                        <Typography variant="body-compact-02-m">body-compact-02-m</Typography>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="border-cf-grey-100 rounded-lg border p-6">
                  <Typography variant="cf-heading-03" className="text-cf-purple-700 mb-4 font-mono">
                    Heading Variants
                  </Typography>
                  <div className="space-y-4">
                    <div>
                      <div className="space-y-4">
                        <Typography variant="cf-heading-01">cf-heading-01</Typography>
                        <Typography variant="cf-heading-compact-01">
                          cf-heading-compact-01
                        </Typography>
                        <Typography variant="cf-heading-02">cf-heading-02</Typography>
                        <Typography variant="cf-heading-compact-02">
                          cf-heading-compact-02
                        </Typography>
                        <Typography variant="cf-heading-03">cf-heading-03</Typography>
                        <Typography variant="cf-heading-compact-03">
                          cf-heading-compact-03
                        </Typography>
                      </div>
                      <CodeExample
                        code={`import { Typography } from '@repo/design-system-cf/components/typography'

// Heading 01 and Compact 01
<Typography variant="cf-heading-01">
  cf-heading-01
</Typography>
<Typography variant="cf-heading-compact-01">
  cf-heading-compact-01
</Typography>

// Heading 02 and Compact 02
<Typography variant="cf-heading-02">
  cf-heading-02
</Typography>
<Typography variant="cf-heading-compact-02">
  cf-heading-compact-02
</Typography>

// Heading 03 and Compact 03
<Typography variant="cf-heading-03">
  cf-heading-03
</Typography>
<Typography variant="cf-heading-compact-03">
  cf-heading-compact-03
</Typography>`}
                      />
                    </div>
                  </div>
                </div>

                <div className="border-cf-grey-100 rounded-lg border p-6">
                  <Typography variant="cf-heading-03" className="text-cf-purple-700 mb-4 font-mono">
                    Label Variants
                  </Typography>
                  <div className="space-y-4">
                    <div>
                      <Typography variant="cf-heading-02" className="text-cf-grey-800 mb-4">
                        Label 01 Variants
                      </Typography>
                      <div className="space-y-4">
                        <Typography variant="cf-label-01">cf-label-01</Typography>
                        <Typography variant="cf-label-compact-01">cf-label-compact-01</Typography>
                        <Typography variant="cf-label-01-M">cf-label-01-M</Typography>
                        <Typography variant="cf-label-compact-01-M">
                          cf-label-compact-01-M
                        </Typography>
                        <Typography variant="cf-label-01-B">cf-label-01-B</Typography>
                        <Typography variant="cf-label-compact-01-B">
                          cf-label-compact-01-B
                        </Typography>
                      </div>

                      <Typography variant="cf-heading-02" className="text-cf-grey-800 mb-4 mt-8">
                        Label 02 Variants
                      </Typography>
                      <div className="space-y-4">
                        <Typography variant="cf-label-02">cf-label-02</Typography>
                        <Typography variant="cf-label-02-compact">cf-label-02-compact</Typography>
                        <Typography variant="cf-label-02-M">cf-label-02-M</Typography>
                        <Typography variant="cf-label-compact-02-M">
                          cf-label-compact-02-M
                        </Typography>
                        <Typography variant="cf-label-02-B">cf-label-02-B</Typography>
                        <Typography variant="cf-label-02-compact-B">
                          cf-label-02-compact-B
                        </Typography>
                      </div>

                      <CodeExample
                        code={`import { Typography } from '@repo/design-system-cf/components/typography'

// Label 01 Variants
<Typography variant="cf-label-01">
  cf-label-01
</Typography>
<Typography variant="cf-label-compact-01">
  cf-label-compact-01
</Typography>
<Typography variant="cf-label-01-M">
  cf-label-01-M
</Typography>
<Typography variant="cf-label-compact-01-M">
  cf-label-compact-01-M
</Typography>
<Typography variant="cf-label-01-B">
  cf-label-01-B
</Typography>
<Typography variant="cf-label-compact-01-B">
  cf-label-compact-01-B
</Typography>

// Label 02 Variants
<Typography variant="cf-label-02">
  cf-label-02
</Typography>
<Typography variant="cf-label-02-compact">
  cf-label-02-compact
</Typography>
<Typography variant="cf-label-02-M">
  cf-label-02-M
</Typography>
<Typography variant="cf-label-compact-02-M">
  cf-label-compact-02-M
</Typography>
<Typography variant="cf-label-02-B">
  cf-label-02-B
</Typography>
<Typography variant="cf-label-02-compact-B">
  cf-label-02-compact-B
</Typography>`}
                      />
                    </div>
                  </div>
                </div>

                <div className="border-cf-grey-100 rounded-lg border p-6">
                  <Typography variant="cf-heading-03" className="text-cf-purple-700 mb-4 font-mono">
                    Custom Component
                  </Typography>
                  <div className="space-y-4">
                    <div>
                      <div className="space-y-4">
                        <Typography asChild variant="body-01">
                          <span>This typography is rendered as a span element</span>
                        </Typography>
                      </div>
                      <CodeExample
                        code={`import { Typography } from '@repo/design-system-cf/components/typography'

// Using asChild to render as a different element
<Typography asChild variant="body-01">
  <span>This typography is rendered as a span element</span>
</Typography>`}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          ),
          api: {
            properties: [
              {
                name: 'variant',
                type: "'body-01' | 'body-compact-01' | 'body-01-m' | 'body-compact-01-m' | 'body-02' | 'body-02-m' | 'body-compact-02' | 'body-compact-02-m' | 'cf-heading-01' | 'cf-heading-compact-01' | 'cf-heading-02' | 'cf-heading-compact-02' | 'cf-heading-03' | 'cf-heading-compact-03' | 'cf-label-01' | 'cf-label-compact-01' | 'cf-label-01-M' | 'cf-label-compact-01-M' | 'cf-label-01-B' | 'cf-label-compact-01-B' | 'cf-label-02' | 'cf-label-02-compact' | 'cf-label-02-M' | 'cf-label-compact-02-M' | 'cf-label-02-B' | 'cf-label-02-compact-B'",
                defaultValue: "'body-01'",
                description: 'The typography style variant to use',
              },
              {
                name: 'asChild',
                type: 'boolean',
                defaultValue: 'false',
                description:
                  'Whether to merge props onto the child instead of creating a new element',
              },
              {
                name: 'className',
                type: 'string',
                defaultValue: 'undefined',
                description: 'Additional CSS classes to apply',
              },
            ],
          },
          changelog: [
            {
              date: '13-06-2025',
              changes: [
                'Adjusted body-compact-01, body-01-m, body-compact-01-m to use font-base instead of font-sm',
                'Adjust cf-title-02-fc variant to leading-5 from leading-6',
              ],
            },
            {
              date: '20-05-2025',
              changes: [
                'Initial version with all typography variants including body and heading styles',
              ],
            },
          ],
          design: (
            <iframe
              style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}
              width="100%"
              height="100%"
              src="https://embed.figma.com/proto/c8oXlEODLmj3csp3ux5DKu/Design-System---Components?node-id=318-4009&m=dev&scaling=min-zoom&content-scaling=fixed&page-id=1%3A34&embed-host=share"
              allowFullScreen
            />
          ),
        }}
      />
    </div>
  )
}
